// extracted by mini-css-extract-plugin
export default {"buttonContainer":"NavigationButtons_buttonContainer__eRyvm","button":"NavigationButtons_button__h3SAU","marginRight":"NavigationButtons_marginRight__M0Eb4"};